import { AxiosRequestConfig } from 'axios'

import { apiRoutes } from '@/config/api-routes'
import { usersApi } from '@/lib/axios'

export interface UrlIntegration {
  auth_url: string
}

export async function getUrlIntegration(options?: AxiosRequestConfig) {
  const { data } = await usersApi.get<UrlIntegration>(
    apiRoutes.getUrlIntegration('john-deere'),
    options,
  )

  return data
}
